import { getAVailableBalances,getGridData,getRecentPayments, get, getNotification } from "./api"
import { isErrorDispaly } from "../../shared/validationsAndExceptions/apiExceptions";
import debounce from "../../utils/debounce";
export const getBalance = async(coinName,customerInfo) =>{
 try{
    let response = await getAVailableBalances(coinName,customerInfo);
    if(response.status === 200){
        return response.data
    }
    else{
      return response
    }    
 }
 catch(error){
    return error
 }
}
export const getPayments = async(url,customerId) =>{
    try{
       let response = await getGridData(url,customerId);
       if(response.status === 200){
           return response.data
       }
       else{
         return response.data;
       } 
    }
    catch(error){
       return error
    }
   }
   export const getCoins = async(url,customerId) =>{
    try{
       let response = await get(url,customerId);
       if(response.status === 200){
           return response.data
       }
       else{
         return response
       } 
    }
    catch(error){
       return error
    }
   }
   export const getTransactionGrid = async (id,search,callback,pageNo,pageSize,transactionType,selectedDates) => {
    pageSize = pageSize || 20;
    let _fromDate = selectedDates.length > 0 ? selectedDates[0] :'' ;
    let _toDate = selectedDates.length > 0 ? selectedDates[1] :'';
    const response = await getRecentPayments(id,search, pageNo, pageSize,transactionType,_fromDate,_toDate);
    if (response.ok) {
      callback(response.data,null)
    } else {
      callback(null,isErrorDispaly(response))
    }
  };
  export const getTypes = async(url) =>{
    try{
       let response = await get(url);
       if(response.status === 200){
           return response.data
       }
       else{
         return response
       } 
    }
    catch(error){
       return error
    }
   }
   export const getNotifications = async(url,customerId,type) =>{
    try{
       let response = await getNotification(url,customerId,type);
       if(response.status === 200){
           return response.data
       }
       else{
         return response
       } 
    }
    catch(error){
       return error
    }
   }
  export const debouncedGrid=debounce(getTransactionGrid,getTypes)